import { $http } from "./index";

//获取报税类型下拉框
export const taxtype_select = () => {
  return $http.get("/admin/Dictionary/getTaxType");
};

//获取发票类型
export const invoice_select = () => {
  return $http.get("/admin/Dictionary/getInvoice");
};

//获取开票方式
export const invoicetype_select = () => {
  return $http.get("/admin/Dictionary/getInvoiceType");
};

//获取开票种类
export const invoicekind_select = () => {
  return $http.get("/admin/Dictionary/getInvoiceKind");
};

//获取行业树
export const industry_tree = () => {
  return $http.get("/admin/Dictionary/getIndustry", { params: { tree: 1 } });
};

//获取开户银行
export const bank_select = () => {
  return $http.get("/admin/PtsDictionary/getBank");
};

//获取到账公示认领用途
export const bankcollected_receivedtype_select = () => {
  return $http.get("/admin/Dictionary/getBankReceivedType");
};

//获取证件类型下拉框数据
export const idtype_select = () => {
  return $http.get("/admin/PtsDictionary/getIdtype");
};

//获取开户行省份
export const openbank_province_select = () => {
  return $http.get("/admin/PtsDictionary/getOpenBankProvince");
};

//获取所得项目
export const income_select = () => {
  return $http.get("/admin/PtsDictionary/getIncome", {
    params: { sort_field: "value" },
  });
};

//获取申诉类型
export const appealtype_select = () => {
  return $http.get("/admin/PtsDictionary/getAppealType");
};

//获取申诉事项
export const appealitem_select = () => {
  return $http.get("/admin/PtsDictionary/getAppealItem");
};

//获取客户类型
export const customertype_tree = (params) => {
  return $http.get("/admin/Dictionary/getCustomerType", { params });
};

//获取客户服务类型
export const customerservice_tree = (params) => {
  return $http.get("/admin/Dictionary/getService", { params });
};

//获取中国银行代发工资摘要
export const salarypayment_type = (params) => {
  return $http.get("/admin/B2eDictionary/getBocFurinfo", { params });
};

//获取免税收入附表
export const secondary_select = (params) => {
  return $http.get("/admin/Secondary/index", { params });
};

//获取国籍地区
export const dic_getNationality = (params) => {
  return $http.get("/admin/PtsDictionary/getNationality", { params });
};
